import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function ProjectCategoriesProvider({
  onChange,
  error,
  helperText,
  blur,
  values,
}) {
  return (
    <Autocomplete
      multiple
      size="small"
      onChange={onChange}
      id="tags-outlined"
      value={Array.isArray(values) ? values : []}
      options={top100Films}
      getOptionLabel={(option) => option}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          error={error}
          helperText={helperText}
          onBlur={blur}
          {...params}
          label="Select Categories"
        />
      )}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  "studio",
  "1-bed",
  "2-bed",
  "3-bed",
  "4-bed",
  "5-bed",
  "commercial",
];
